import EditQuoteTypeOptionDialog from './EditQuoteTypeOptionDialog'

export default EditQuoteTypeOptionDialog
